var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',[_c('b-card',{attrs:{"title":"Informes SBG"}},[_c('b-card-text',[_vm._v("Seleccione una opción en el menú a la izquierda.")])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }